import { faArrowDownArrowUp } from "@fortawesome/pro-solid-svg-icons"; 
import { library } from '@fortawesome/fontawesome-svg-core';
import SafeFontAwesomeIcon from "../../SafeFontAwesomeIcon";

// library.add(faArrowDownArrowUp);

const iconMap = {
  faArrowDownArrowUp: faArrowDownArrowUp,
};

function UIIconForm({
  Icon,
  color = "#c4c4c4",
  size,
  iconSize,
  swapOpacity,
  spin,
  plus,
  flip,
  rotation,
  border,
  onClick,
  style = {},
  className = "",
}) {
  const iconToRender = iconMap[Icon]; 

  return (
    <SafeFontAwesomeIcon
      className={className}
      onClick={onClick}
      icon={iconToRender}
      style={{ color: color, fontSize: size ? size : 16, ...style }}
      swapOpacity={swapOpacity}
      spin={spin}
      pulse={plus}
      flip={flip}
      rotation={rotation}
      border={border}
    />
  );
}

export default UIIconForm;
